/**
 * Created by saltrichter on 7/10/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        ApiResources = require("assets/data/apiResources.json"),
        BaseCollection = require("collections/BaseCollection"),
        NotificationModel = require("connection-models/notificationTab/NotificationModel"),
        LEResourceResolver = require("leResourceResolver"),
        CP_CONST = require("connection-const"),
        NTF_CONST = CP_CONST.NOTIFICATIONS,
        Privileges = require("codeTables/privileges.json"),
        NotificationCollection = {};

    var agentLEManager = require('web-agent-utils/agentLEManager');
    var fetchInterval = NTF_CONST.FETCH_INTERVAL_REST;
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;
        NotificationCollection = BaseCollection.extend({
            model: NotificationModel,
            resource: ApiResources.ConnectionPanel.Notifications_Rest,
            socketAPI: null,
            comparator: function (item) {
                return -item.getTimestamp();
            },
            initialize: function (models, options) {
                options = options || {};
                this.channel = options.channel;
                this.visibility = options.visibility;
                this.contextModel = options.contextModel;
                this.contextModel.setNotificationsCollection(this); // bind this collection to the content model for counter computing
                this.apiInitialized = false;

                this._setupNotificationPermissions();
                this._initCollectionFromLocalStorage();
                this._bindEvents();
                this._initConnection();// now we will connect to the backend

                logger.debug('initialize: success initializing!');
            },

            _setupNotificationPermissions: function () {
                this.hasAccountLevelNotifications = LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.VIEW_ACCOUNT_LEVEL_NOTIFICATIONS) || false;
                this.hasUserLevelNotifications = LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.VIEW_USER_LEVEL_NOTIFICATIONS) || false;
            },

            _initCollectionFromLocalStorage: function () {
                logger.debug("NotificationCollection._loadFromLocalStorage: loading existing notifications from storage if any.");
                this._createLocalStoragePrefix();
                this._loadFromLocalStorage(); // now load existing notifications from local storage if any
                this._saveCollectionToLocalStorage();
            },

            _createLocalStoragePrefix: function () {
                this.storagePrefix = LE.sessionManager.getAccountId() + ':' + LE.sessionManager.getUserId() + NTF_CONST.LOCAL_STORAGE_VAR;
            },

            _loadFromLocalStorage: function () {
                if (LEConnection.parentManager && LEConnection.parentManager.getFromLocalStorage) {
                    var storedNotifications = JSON.parse(LEConnection.parentManager.getFromLocalStorage(this.storagePrefix)) || [];
                    _.each(storedNotifications, this._updateFromData, this);
                }
            },

            _updateFromData: function (data) {
                logger.debug('_updateFromData: received new notification from WS backend, :', data);
                try {
                    var newNotification = new NotificationModel(data);
                    this._addNotificationEvent(newNotification);
                } catch (error) {
                    logger.error("Failed to create and add notification event", "NotificationCollection:_updateFromData", error);
                }
            },

            _addNotificationEvent: function (model) {
                var viewAccountNotifications = this.hasAccountLevelNotifications && model.isAccountLevelNotification();
                var viewUserNotifications = this.hasUserLevelNotifications && model.isUserLevelNotification();
                if (model.isForNotificationCenter() &&
                    !model.isExpired() &&
                    (viewAccountNotifications || viewUserNotifications) && this.contextModel.isNotificationCenterEnabled()) {
                    this.add(model);
                } else if (model.isUnreadMessagesNotification()) {
                    this.channel.vent.trigger('messaging:receivedUnreadNotification', model.getUnreadMessagesData());
                } else {
                    logger.warn('Received unknown notification center event', 'NotificationCollection._addNotificationEvent', model);
                }
            },

            _saveCollectionToLocalStorage: function () {
                if (LEConnection.parentManager && LEConnection.parentManager.saveInLocalStorage) {
                    var notExpiredNotifications = this.filter(function (model) {
                        return !model.isExpired();
                    }).map(function (notification) {
                        return notification.toPersistenceModel();
                    });
                    LEConnection.parentManager.saveInLocalStorage(this.storagePrefix, JSON.stringify(notExpiredNotifications));
                }
            },

            _bindEvents: function () {
                this.listenTo(this, 'change:reminders', this.sort, this);
                this.listenTo(this, 'change', this._saveIfInternalAttributeHasChanged, this);
                this.listenTo(this, 'add remove', this._saveCollectionToLocalStorage, this);
                this.listenTo(this, 'add', this._onNewAddedModel, this);
                this.listenTo(this.channel, 'messaging:subscribeForUnreadMessages', this._subscribeForUnreadMessages, this);
            },

            _saveIfInternalAttributeHasChanged: function (model) {
                if (model.hasInternalAttributeChanged()) {
                    this._saveCollectionToLocalStorage();
                }
            },

            _onNewAddedModel: function (model) {
                this._showDesktopNotification(model);
            },

            _showDesktopNotification: function (model) {
                var iconUrl = model.isCritical() ? "src/modules/connection/assets/img/incoming-critical-event.png" : "src/modules/connection/assets/img/incoming-message-LP.png";
                var desktopNotification = {
                    DesktopNotification: {
                        title: model.getTitle(),
                        body: model.getDescription(),
                        iconUrl: iconUrl,
                        onClick: _.bind(this._openEvent, this, model)
                    }
                };
                agentLEManager.notificationCenterNotify(desktopNotification);
            },

            _openEvent: function (model) {
                LEConnection.vent.trigger("TabsController:switchTab", {tab: CP_CONST.TABS.NOTIFICATION});
                model.setItemRead();
                this.channel.vent.trigger("NotificationTabController::notification:display", model);
            },

            _initConnection: function () {
                this.socketAPI =  this._initSocketConnection();
                if (!this.socketAPI || !this.socketAPI.supported) {
                    logger.warn('NotificationCollection.initConnection: could not establish a WS connection, downgrading to postmessage!');
                    this._initPostMessageConnection();
                }
                this.apiInitialized = true;
                this.channel.vent.trigger('api:initialized');
            },

            _initSocketConnection: function () {
                LEConnection.logger.debug("NotificationCollection.initSocketConnection: started initializing WS connection.");
                var config = ApiResources.ConnectionPanelNotifications.endpoint.configuration;
                var socketConf = {
                    server: LEResourceResolver.getUrl(ApiResources.ConnectionPanelNotifications.notificationsUrl),
                    created: _.bind(function () {
                        LEConnection.logger.debug("NotificationCollection.initSocketConnection: successfully created WS connection.");
                        this._authenticateSocketConnection();
                    }, this),
                    message: _.bind(function (data) {
                        LEConnection.logger.debug("NotificationCollection.socketConnection: received message from server.", data);
                        if (data[NTF_CONST.AUTH_INDICATOR]) {
                            this.socketAPI.authenticated = true;
                            this.channel.vent.trigger('socketAPI:authenticated');
                        }
                        else if (data[NTF_CONST.MSG_PREFIX] && data[NTF_CONST.MSG_PREFIX] !== NTF_CONST.PONG.message) {
                            this._updateFromData(data[NTF_CONST.MSG_PREFIX]);
                        }
                    }, this),
                    closed: _.bind(function (data) {
                        LEConnection.logger.debug("NotificationCollection.socketConnection: Connection was closed. Reason: " + data);
                    }, this),
                    autoReconnect: config.autoReconnect,
                    maxReconnectAttempt: config.maxReconnectAttempt,
                    reconnectTimeout: config.reconnectTimeout,
                    ping: {request: NTF_CONST.PING, response: NTF_CONST.PONG}
                };
                return new lpTag.taglets.LPWebSocketWrapper(socketConf);
            },

            _authenticateSocketConnection: function () {
                LEConnection.logger.debug("NotificationCollection.initSocketConnection: sending authentication request.");
                var authObjString = NTF_CONST.AUTH_JSON_STRING
                    .replace('{bearer}', LE.sessionManager.getGlob())
                    .replace('{accountId}', LE.sessionManager.getAccountId())
                    .replace('{userId}', LE.sessionManager.getUserId());
                this.socketAPI.send(JSON.parse(authObjString));
            },

            _initPostMessageConnection: function () {
                this.resource.url = LEResourceResolver.getUrl(this.resource.url);
                setInterval(_.bind(function () {
                    this.fetch({remove: false, merge: true});
                }, this), fetchInterval);
                this.fetch({remove: false, merge: true});
            },

            parse: function (response) {
                logger.debug('parse: received a response from server:', response);
                if (_.isArray(response)) {
                    response.forEach(_.bind(function (current) {
                        this._updateFromData(current[NTF_CONST.MSG_PREFIX]);
                    }, this));
                }
            },

            countUnreadNotifications: function () {
                var counter = 0;
                this.forEach(function (model) {
                    if (!model.isRead()) {
                        counter += 1;
                    }
                });
                return counter;
            },

            hasCritical: function () {
                return Boolean(this.find(function (model) {
                    return model.isCritical() && !model.isRead();
                }));
            },

            _sendUnreadMsgSubscription: function (payload) {
                if (this.socketAPI && this.socketAPI.supported) {
                    logger.debug('subscribing for unread messages', payload);
                    this._unreadMessagesSubscriptionData = this._createUnreadMessagesSubscriptionPayload(payload);
                    if (this.socketAPI.authenticated) {
                        this.socketAPI.send(this._unreadMessagesSubscriptionData);
                    }
                    // always bind to the authenticated event, so we can handle reconnects
                    this.listenTo(this.channel.vent, 'socketAPI:authenticated', function () {
                        this.socketAPI.send(this._unreadMessagesSubscriptionData);
                    }, this);

                } else {
                    this.channel.vent.trigger('socketAPI:notSupported');
                }
            },

            _subscribeForUnreadMessages: function (payload) {
                if (this.apiInitialized) {
                    logger.debug('api initialized, sending messaging subscription');
                    this._sendUnreadMsgSubscription(payload);
                } else {
                    logger.debug('api not initialized yet, binding to \'api:initialized\' event');
                    this.listenTo(this.channel.vent, 'api:initialized', function () {
                        this._sendUnreadMsgSubscription(payload);
                    }, this);
                }
            },

            _createUnreadMessagesSubscriptionPayload: function (payload) {
                return {
                    message: NTF_CONST.MESSAGING_SUBSCRIPTION,
                    data: payload
                };
            }

        });
    });

    return NotificationCollection;
});
